import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';

type Props = {
  summary: any;
};

const money = (v: any) =>
  Number(v || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 });

class BudgetAllocationSummaryPanel extends React.Component<Props> {
  renderMetric(label: string, value: any) {
    return (
      <Grid size={{ xs: 6, sm: 4, md: 2 }} key={label}>
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {value ?? 0}
        </Typography>
      </Grid>
    );
  }

  render() {
    const s = this.props.summary || {};

    return (
      <Card elevation={1}>
        <CardContent>
          <Grid container spacing={2}>
            {this.renderMetric('Cost Centers', s.costcenters)}
            {this.renderMetric('Activities', s.activities)}
            {this.renderMetric('Allocated', s.allocated_activities)}
            {this.renderMetric('Unallocated', s.unallocated_activities)}
            {this.renderMetric('Links', s.allocation_links)}
            {this.renderMetric('Amount', money(s.allocated_amount))}
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default BudgetAllocationSummaryPanel;
